import { usePlatformsSectionContent } from './usePlatformsSectionContent';
import { parsePlatformsHeroContent } from '../utils/platformsContent';

export const usePlatformsHeroContent = () =>
  usePlatformsSectionContent(parsePlatformsHeroContent);
